$(() => {
  const pluginName = 'membershipsPlugin';
  const dataKey = `plugin_${pluginName}`;

  let settings = {};
  let $pluginContainer = null;
  let plugin = null;

  /**
   * Enable or disable the membership selection fields (and the submit button)
   * @param enabled
   * @param $element
   */
  const toggleMembershipSelectionFields = function toggleMembershipSelectionFields(enabled, $element) {
    const $clubContainer = $element.closest('.js-club-membership');

    $clubContainer.find(settings.selectors.membershipSelectionFields)
      .prop('disabled', !enabled).toggleClass('disabled', !enabled);
  };

  /**
   * Set the loading state of the membership validation
   * @param $element
   */
  const loadingValidation = function loadingValidation($element) {
    const $clubContainer = $element.closest('.js-club-membership');

    toggleMembershipSelectionFields(false, $element);
    $clubContainer.find(settings.selectors.membershipIdFormGroup)
      .removeClass('has-success has-error')
      .find('.form-control-feedback')
      .removeClass('fa-check-circle fa-times-circle');
    $clubContainer.find(settings.selectors.feedback)
      .removeClass('hidden').html(settings.i18n.memberships.validating);
  };

  /**
   * The membership isn't valid so make things red and sad
   * @param error
   * @param $element
   */
  const invalidMembershipCall = (error, $element) => {
    const $clubContainer = $element.closest('.js-club-membership');
    const $input = $clubContainer.find(settings.selectors.membershipId);

    $clubContainer
      .find(settings.selectors.membershipIdFormGroup)
      .addClass('has-error')
      .removeClass('has-success')
      .find('.form-control-feedback')
      .addClass('fa-times-circle')
      .removeClass('fa-check-circle');
    $input.trigger('focus');
    $input[0].select();
    $clubContainer.find(settings.selectors.feedback).removeClass('hidden').html(error);
  };

  /**
   * It worked!
   *  @param $element
   */
  const validMembershipCall = ($element) => {
    const $clubContainer = $element.closest('.js-club-membership');

    $clubContainer.find(settings.selectors.membershipIdFormGroup)
      .addClass('has-success')
      .removeClass('has-error')
      .find('.form-control-feedback')
      .addClass('fa-check-circle')
      .removeClass('fa-times-circle');
    $clubContainer.find(settings.selectors.feedback)
      .removeClass('hidden').html(settings.i18n.memberships.validated);
  };

  /**
   * Validate membership ID against event/club association
   */
  const validateMembership = (event) => {
    const $submit = $(event.currentTarget);
    const $clubWrapper = $submit.closest('.js-club-membership');
    const clubId = $clubWrapper.find(settings.selectors.submit).data('club');
    const $membership = $clubWrapper.find(settings.selectors.membershipId);
    const membershipId = $membership.val().trim();
    const email = settings.personalInformation.form.find('.js-email').val();
    const birthDate = settings.personalInformation.form.find('.js-dob').val();

    $submit.preventDoubleSubmission('disable');

    if (membershipId.length === 0) {
      $membership.trigger('focus');
      $submit.preventDoubleSubmission('reEnable');
      return;
    }

    loadingValidation($submit);

    const data = {
      membership_id: membershipId,
      club_id: clubId,
    };

    if (email) {
      data.email = email;
    }

    if (birthDate) {
      data.birth_date = birthDate;
    }

    $.ajax({
      url: settings.membershipValidationUrl,
      type: 'post',
      data,
    })
      .done(() => validMembershipCall($submit))
      .fail((response) => {
        invalidMembershipCall(settings.registrationPlugin.parseErrorMessage(response), $submit);
      })
      .always(() => {
        $submit.preventDoubleSubmission('reEnable');
        toggleMembershipSelectionFields(true, $submit);
      });
  };

  /**
   * When the text is blurred, clear the select value
   */
  const membershipInputBlur = function membershipInputBlur() {
    const $this = $(this);
    const $select = $this.closest('.js-club-membership').find(settings.selectors.membershipSelect);

    if ($select.length && $this.val() !== $select.val()) {
      $select.val('');
    }
  };

  /**
   * When the select is used, put the value in the text box
   */
  const syncMembershipId = function membershipSelectChange() {
    const $this = $(this);
    $this.closest('.js-club-membership').find(settings.selectors.membershipId).val($(this).val());
  };

  /**
   * If they're buying a membership, don't let em validate
   */
  const purchaseMembershipCheck = function purchaseMembershipCheck() {
    const $this = $(this);

    toggleMembershipSelectionFields(!$this.is(':checked'), $this);
  };

  /**
   * Hello world
   */
  const initialize = () => {
    $pluginContainer.on('blur', settings.selectors.membershipId, membershipInputBlur);
    $pluginContainer.on('click', settings.selectors.submit, validateMembership);
    $pluginContainer.on('change', settings.selectors.membershipSelect, syncMembershipId);
    $pluginContainer.on('change', settings.selectors.purchase, purchaseMembershipCheck);
  };

  /**
   * Build it up
   * @param element
   * @param options
   * @constructor
   */
  const Plugin = function Plugin(element, options) {
    plugin = this;
    plugin.element = element;
    plugin.settings = {
      registrationPlugin: null,
      personalInformation: null,
      registrationUrl: null,
      membershipValidationUrl: null,
      i18n: {},
      selectors: {
        membershipSelectionFields: '.js-membership-selection-fields',
        membershipSelect: '.js-membership-select',
        membershipIdFormGroup: '.js-membership-id-form-group',
        membershipId: '.js-membership-id',
        submit: '[data-js-membership-validate]',
        purchase: '.js-membership-purchase',
        feedback: '.js-membership-feedback',
      },
    };

    settings = $.extend(plugin.settings, options);
    $pluginContainer = element;
    initialize();
  };

  /**
   * Clear the plugin's contents
   */
  Plugin.prototype.clear = () => {
    $pluginContainer.empty();
  };

  /**
   * Toggle the visibility of this component
   *
   * @param isVisible
   */
  Plugin.prototype.toggleVisibility = (isVisible) => {
    $pluginContainer.toggleClass('hidden', !isVisible);
  };

  /**
   * Display the plugin's contents
   * @param content
   */
  Plugin.prototype.displayContent = (content) => {
    if (content) {
      $pluginContainer
        .html(content)
        .find(settings.selectors.submit)
        .preventDoubleSubmission();
    }
  };

  /**
   * Initialize the functional components of the content
   */
  Plugin.prototype.initializeContent = () => {
    Plugin.prototype.displayContent();
  };

  /**
   * Plugin wrapper, preventing against multiple instantiations and
   * return plugin instance.
   */
  $.fn[pluginName] = function pluginWrapper(options) {
    let thisPlugin = this.data(dataKey);

    // has plugin instantiated ?
    if (thisPlugin instanceof Plugin) {
      // if have options arguments, call plugin.init() again
      if (typeof options !== 'undefined') {
        thisPlugin.init(options);
      }
    } else {
      thisPlugin = new Plugin(this, options);
      this.data(dataKey, thisPlugin);
    }

    return thisPlugin;
  };
});
